export default __webpack_public_path__ + "static/media/musica_loop_02.41bad9c0.mp3";